export const buffsData = {
  'tool_cleaver': {
    id: 'tool_cleaver', type: 'ap_discount',
    condition: (context) => context.actionId === 'action_chop',
    effect: (currentApCost) => Math.max(0, currentApCost - 1)
  },
  'tool_mortar': {
    id: 'tool_mortar', type: 'price_multiplier',
    condition: (context) => context.primaryAction === 'action_pound', 
    effect: (currentPrice) => Math.floor(currentPrice * 1.5)
  },
  'tool_brass_pan': {
    id: 'tool_brass_pan', type: 'price_adder',
    condition: (context) => context.primaryAction === 'action_boil',
    effect: (currentPrice) => currentPrice + 20
  },
  'tool_iron_wok': {
    id: 'tool_iron_wok', type: 'price_multiplier',
    condition: (context) => context.primaryAction === 'action_stir_fry',
    effect: (currentPrice) => Math.floor(currentPrice * 1.5)
  },
  'tool_charcoal_grill': {
    id: 'tool_charcoal_grill', type: 'price_adder',
    condition: (context) => context.primaryAction === 'action_grill',
    effect: (currentPrice) => currentPrice + 25
  },
  'tool_mixing_bowl': {
    id: 'tool_mixing_bowl', type: 'ap_discount',
    condition: (context) => context.actionId === 'action_mix',
    effect: (currentApCost) => Math.max(0, currentApCost - 1)
  },
  'tool_deep_fryer': {
    id: 'tool_deep_fryer', type: 'price_multiplier',
    condition: (context) => context.primaryAction === 'action_fry',
    effect: (currentPrice) => currentPrice * 2
  }
};